import { render, staticRenderFns } from "./CmsPresetSelect.vue?vue&type=template&id=2d4d3552&"
import script from "./CmsPresetSelect.vue?vue&type=script&lang=ts&"
export * from "./CmsPresetSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports